import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { useLiberisContext } from '@repo/app-contexts/liberis';
import { Input, SharesInputMask } from '@repo/ui';

import { EditableRow } from '../common/components/editable-row';
import { PostalAddressForm } from '../common/components/postal-address-form';
import { KrsLink } from './krs-link';

export const BeneficientData = () => {
  const { t } = useTranslation();
  const { activeBeneficientIndex } = useLiberisContext();

  const beneficientFields = [
    {
      label: t('welcomePage.loanApplicationPossible.liberis.beneficientData.form.phoneNumber'),
      fieldName: `person[${activeBeneficientIndex}].phone`,
      fieldType: 'text',
    },
    {
      label: t('welcomePage.loanApplicationPossible.liberis.beneficientData.form.email'),
      fieldName: `person[${activeBeneficientIndex}].email`,
      fieldType: 'text',
    },
  ];

  return (
    <Box>
      {beneficientFields.map((field, index) => (
        <EditableRow {...field} index={index} key={field.fieldName} />
      ))}
      <PostalAddressForm
        fieldsName={{
          postCode: `person[${activeBeneficientIndex}].address.postCode`,
          city: `person[${activeBeneficientIndex}].address.city`,
          street: `person[${activeBeneficientIndex}].address.street`,
          country: `person[${activeBeneficientIndex}].address.country`,
        }}
      />
      <Grid container spacing={{ xs: 2, md: 4 }} sx={{ marginTop: '42px' }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Input
            label={t(
              'welcomePage.loanApplicationPossible.liberis.beneficientData.partnershipForm.enterParticipationPercentage',
            )}
            variant="outlined"
            name={`person[${activeBeneficientIndex}].shares`}
            slotProps={{
              input: {
                // @ts-expect-error Issue with the component types, more info here: https://github.com/s-yadav/react-number-format/issues/805,
                // official example with any https://codesandbox.io/p/sandbox/vigorous-zhukovsky-5m7nxt?file=%2Fsrc%2FDemo.tsx%3A89%2C1-90%2C1
                inputComponent: SharesInputMask,
              },
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <KrsLink />
        </Grid>
      </Grid>
    </Box>
  );
};
